import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";
import { post } from "@rails/request.js"

const URL = "/staff/template_room_parts"

export default class extends Controller {
    connect() {
        this.sortable = Sortable.create(this.element, {
            onEnd: this.end.bind(this),
            sort: false,
            animation: 150,
            handle: '.item-handle',
            group: {
                name: 'shared',
                pull: 'clone',
                put: false
            }
        })
    }

    end(event) {

        let partContainer = event.item.closest('.template-room-part-container');
        if(partContainer === null) return;

        let id = event.item.dataset.id;
        event.item.id = "new_template_room_part"; //we change this so we can target it with a turbo_stream

        let data = new FormData();
        data.append('template_room_part[position]', event.newIndex + 1);
        data.append('template_room_part[template_room_id]', partContainer.dataset.id);
        data.append('template_room_part[part_id]', id)

        post(URL, {body: data, responseKind: 'turbo-stream'});

    }

}